<ion-toolbar color="secondary" class="app-header">
  <ion-buttons *ngIf="isAuthenticated" slot="start">
    <ion-menu-button></ion-menu-button>
  </ion-buttons>
  <div class="logo-container">
    <a class="logo-link" (click)="goHome()" aria-label="Home">
      <img src="assets/logos/social-dash-logo-with-white-circle.png" alt="Social Dash Logo" />
    </a>
    <span class="beta-badge">BETA</span>
  </div>
  <ion-buttons *ngIf="isAuthenticated" slot="end">
    <ion-button *ngIf="showMenu && showAiButton" class="ai-button" fill="clear" aria-label="Open Em" (click)="openAiCopilot()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14" aria-hidden="true">
        <path d="M12 2l1.5 7.5L21 11l-7.5 1.5L12 20l-1.5-7.5L3 11l7.5-1.5Z"/>
        <path d="M19.5 3l.6 1.9 1.9.6-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6Z"/>
        <path d="M5 18l.6 1.9 1.9.6-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6Z"/>
      </svg>
      <span class="ai-label">AI</span>
    </ion-button>
    <ion-button *ngIf="showMenu" class="notif-btn" aria-label="Notifications" (click)="openNotifications($event)">
      <ion-icon name="notifications-outline" style="font-size: 18px;"></ion-icon>
      <span *ngIf="unreadCount > 0" class="notification-dot" aria-hidden="true"></span>
    </ion-button>
    <ion-button *ngIf="showMenu" class="hide-on-mobile" aria-label="Help" (click)="openHelp()">
      <ion-icon name="help-circle-outline"></ion-icon>
    </ion-button>
    <ion-button (click)="openProfileMenu($event)">
      <ion-avatar color="primary" class="profile-logo">
        <img [src]="profileImage" alt="User Logo" />
      </ion-avatar>
    </ion-button>
  </ion-buttons>
</ion-toolbar>

<!-- Popover for notifications -->
<ion-popover [event]="notificationsEvent" [isOpen]="isNotificationsOpen" (ionPopoverDidDismiss)="closeNotifications()" style="--width: 350px;">
  <ng-template>
    <ion-content class="ion-padding">
      <div class="notifications-header">
        <div class="title">Notifications</div>
        <div class="actions">
          <ion-button size="small" fill="clear" color="danger" (click)="clearAllNotifications()">Clear</ion-button>
        </div>
      </div>
      <ion-list *ngIf="notifications.length > 0; else noNotifications">
        <ion-item *ngFor="let n of notifications" lines="full" button (click)="handleNotificationClick(n)">
          <ion-icon [name]="n.type === 'success' ? 'checkmark-circle' : (n.type === 'error' ? 'alert-circle' : 'information-circle')" 
                    [color]="n.type === 'success' ? 'success' : (n.type === 'error' ? 'danger' : 'primary')" 
                    slot="start"></ion-icon>
          <ion-label class="ion-text-wrap">
            <h2 [style.fontWeight]="n.read ? 'normal' : 'bold'">{{ n.title }}</h2>
            <p>{{ n.message }}</p>
            <p style="font-size: 12px; color: gray;">{{ n.date | date:'short' }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ng-template #noNotifications>
        <div class="ion-text-center ion-padding">
          <p>No notifications</p>
        </div>
      </ng-template>
    </ion-content>
  </ng-template>
</ion-popover>

<!-- Popover for profile options -->
<ion-popover [event]="popoverEvent" [isOpen]="isPopoverOpen" (ionPopoverDidDismiss)="closePopover()">
  <ng-template>
      <ion-list>
      <ion-item *ngIf="showMenu" class="clickable" lines="full" (click)="settings()">
        <div slot="start" class="ic_div">
          <ion-icon color="primary" class="icon" name="settings-outline"></ion-icon>
        </div>
        <ion-label>Settings</ion-label>
      </ion-item>

      <!-- Switch accounts: route to Accounts page to view/add/select accounts -->
      <ion-item *ngIf="hasSwitchAccountAccess && showMenu" class="clickable" lines="full" (click)="goToAccounts()">
        <div slot="start" class="ic_div">
          <ion-icon color="primary" class="icon" name="swap-horizontal-outline"></ion-icon>
        </div>
        <ion-label>Switch Account</ion-label>
      </ion-item>

      <ion-item *ngIf="showMenu" class="clickable" lines="full" (click)="support()">
        <div slot="start" class="ic_div">
          <ion-icon color="primary" class="icon" name="help-buoy-outline"></ion-icon>
        </div>
        <ion-label>Support</ion-label>
      </ion-item>

      <ion-item *ngIf="showMenu" class="clickable" lines="full" (click)="openHelp(); closePopover()">
        <div slot="start" class="ic_div">
          <ion-icon color="primary" class="icon" name="help-circle-outline"></ion-icon>
        </div>
        <ion-label>Help</ion-label>
      </ion-item>

      <!-- Linked profiles removed: functionality replaced by accounts feature -->

      <ion-item class="clickable" lines="none" (click)="logout()">
        <div slot="start" class="ic_div">
          <ion-icon color="primary" class="icon" name="log-out-outline"></ion-icon>
        </div>
        <ion-label>Logout</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>